import { Link } from "react-router";

import style from "../style/Footer.module.css";

export default function Footer() {
    return (
        <div className={style.container}>
            <div className={style.columns}>
                <div>
                    <a href="https://profiles.eco/albrecht?ref=tm" rel="noreferrer" target={"_blank"}>
                        <img
                            className={style.trustmark}
                            alt=".eco profile for albrecht.eco"
                            src="https://trust.profiles.eco/albrecht/eco-mark.svg?color=%239F1744"
                            style={{ maxWidth: "6rem" }}
                        />
                    </a>
                </div>

                <div className={style.links}>
                    <div>
                        <Link to={"/"}>Home</Link>
                        <Link to={"/legal"}>Legal Notice</Link>
                    </div>

                    <div>
                        <a href={"https://linkedin.com/in/emil-albrecht"} target={"_blank"} rel={"noreferrer"}>LinkedIn</a>
                        <a href={"https://github.com/n0chteil"} target={"_blank"} rel={"noreferrer"}>GitHub</a>
                    </div>
                </div>
            </div>
        </div>
    );
}